// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__NJj9X","pagination__button":"Pagination_pagination__button__Cw0Wb","pagination__buttonActive":"Pagination_pagination__buttonActive__1FYPX"};